module.exports = __webpack_public_path__ + "static/media/404errorMessage.05cec53b.svg";